/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespRefineMenuStoneCutSelect_itemSearch$ref = any;
export type SbRespRefineMenuFilterStoneCut_itemSearch$ref = any;
export type SbRespRefineMenuFilterStoneCut_itemSearch = {
    readonly " $fragmentRefs": SbRespRefineMenuStoneCutSelect_itemSearch$ref;
    readonly " $refType": SbRespRefineMenuFilterStoneCut_itemSearch$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuFilterStoneCut_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuStoneCutSelect_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = 'f3308bf86fbdcc031312348564a8b609';
export default node;
